/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import logLib from 'gtz.web.lib.logger';
import { NODE_ENV, LOGGER_CONFIG } from '../../env';

/**
 * Parses a  logger config
 * @param {object} config - Logger config
 */
const parseConfig = (config) => {
  // Temprary override config
  const overrideConfig = {
    transports: [
      {
        name: 'Console',
        config: {
          format: 'console',
          level: 'silly',
        },
      },
    ],
  };

  return overrideConfig;

  // TODO: Properly setup logger against config
  /** try {
    return JSON.parse(config);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Logger config not valid json. Using empty config');
    return JSON.parse('{}');
  } **/
};

let logConfig = parseConfig(LOGGER_CONFIG);

if (!logConfig.transports) {
  logConfig = { transports: [] };

  if (NODE_ENV !== 'production') {
    logConfig.transports.push({
      name: 'Console',
      config: {
        format: 'console',
        level: 'silly',
      },
    });
  }
}

logLib.init(logConfig);
const { logger } = logLib;

export default logger;
